module.exports = __webpack_public_path__ + "img/box3.1bf5b25b.png";